<template>
  <VcMenu
    :offset-y="true"
    v-bind="$attrs"
    :close-on-content-click="closeOnContentClick"
    :data-qa="`${dataQa}-VcMenu`"
    v-on="$listeners">
    <template #activator="activatorObj">
      <slot v-bind="activatorObj" name="activator" />
    </template>
    <VcLayout column class="VcDropdown-wrapper" :style="{ maxHeight: maxHeight }" :data-qa="dataQa">
      <VcLayout class="header-area" :data-qa="`${dataQa}-header`">
        <slot name="header" />
      </VcLayout>
      <VcLayout class="content-area" :data-qa="`${dataQa}-content`" :style="contentAreaStyle">
        <slot />
      </VcLayout>
      <VcLayout class="footer-area" :data-qa="`${dataQa}-footer`">
        <slot name="footer">
          <VcLayout v-if="showAddAnother" column>
            <v-divider />
            <VcBaseListItem :data-qa="`${dataQa}-add`" @click="(data) => $emit('onAddItem', data)">
              <VcIcon size="12" class="add-another-icon" dense> $plus </VcIcon>
              <span class="add-another-label">{{ getAddAnotherLabel }}</span>
            </VcBaseListItem>
          </VcLayout>
        </slot>
      </VcLayout>
    </VcLayout>
  </VcMenu>
</template>

<script>
import VcLayout from '../VcLayout/VcLayout.vue';
import VcMenu from '../VcMenu/VcMenu.vue';
import VcBaseListItem from '../list/VcBaseListItem/VcBaseListItem.vue';
import VcIcon from '../VcIcon/VcIcon.vue';

export default {
  name: 'VcDropdown',
  components: { VcBaseListItem, VcLayout, VcMenu, VcIcon },
  props: {
    /**
     * If set to true and no content has been placed inside the footer slot, it will contain a separator and an "add another" item, as an easy shortcut.
     */
    showAddAnother: {
      type: Boolean,
      default: false,
    },
    /**
     * If you use the built in "add another" footer element, this will allow you to customize the label
     */
    addAnotherLabel: {
      type: String,
      default: '',
    },
    /**
     * Max height in pixels. additional content will be scrolled.
     */
    maxHeight: {
      type: String,
      default: '297px',
    },
    dataQa: {
      type: String,
      default: 'VcDropdown',
    },
    closeOnContentClick: {
      type: Boolean,
      default: false,
    },
    contentAreaStyle: {
      type: String,
      default: 'minWidth: 220px',
    },
  },
  computed: {
    getAddAnotherLabel() {
      return this.addAnotherLabel || this.$dst('ds.menu.add');
    },
  },
};
</script>

<style scoped lang="scss">
.VcDropdown-wrapper {
  background-color: #ffffff;
}

.content-area {
  overflow-y: auto;
  overflow-x: hidden;
}

.add-another-label {
  font-weight: var(--font-weight-medium2);
  font-size: var(--font-size-x-small);
  line-height: var(--size-value5);
  color: var(--gray-darken-5);
}

.add-another-icon {
  margin-inline-end: var(--size-value3);
  cursor: pointer;
}
</style>
